export default "__VITE_ASSET__47j$4GnS__"